import { ComponentConfigurationClass } from "@zoovu/runner-browser-api";
import { ConfigurationValues, ValuesConfigurationConstructor } from "./values";

/**
 * @title Question Configuration
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.Question)
@ComponentConfigurationClass("questionConfiguration")
export class QuestionConfiguration {
    /**
     * @description Indicates if question images should be shown or not
     */
    public showImages?: boolean;

    /**
     * @description Indicates if question purpose is displayed above the navigation bar
     */
    public showQuestionPurpose?: boolean;
}
